<!-- css -->
<style type="text/css" scoped>
.county {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}

.county-title {
  margin-top: 40px;
  color: #333333;
  font-size: 16px;
}

.county-routes {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  align-items: center;
}

.router-link {
  font-size: 14px;
  color: #EEB862;
  line-height: 30px;
}

</style>
<!-- html -->
<template>
  <div class="county">
    <!-- title -->
    <span class="county-title">您可能感兴趣的县区</span>
    <!-- routes -->
    <div class="county-routes">
      <router-link class="router-link" v-for="(item ,index) in routes" :to="{name:'charts',params:{
              name:item.name,distance:item.distance,type:0,from:'list'}}" :key="index">
        {{item.name}}
      </router-link>
    </div>
  </div>
</template>
<!-- javascript -->
<script type="text/javascript">
import {
  Toast,
  Indicator
} from 'mint-ui'
import Fetch from '../../common/fetch'
import Storage from '../../common/storage'
import Tool from '../../common/tool'
export default {
  name: 'county',
  watch: {
    status: function(newVal, oldVal) {
      this.loadCountyNearbyReq()
    }
  },
  computed: {
    routes: function(argument) {
      return this.$store.state.counties
    },
    status: function(argument) {
      return this.$store.state.countyStatus
    }
  },
  data: function(argument) {
    return {}
  },
  mounted: function(argument) {
    this.loadCountyNearbyReq()
    this.initUi()
  },
  methods: {
    initUi: function(argument) {
      document.getElementsByClassName('county')[0].style.height = (document.body.clientHeight - 128) + 'px'
    },
    // 用户查询附件区县
    loadCountyNearbyReq: function(argument) {
      let _this = this
      var userInfo = Storage.queryItem('userInfo')
      if (userInfo === null) {
        Toast({
          message: '请检查参数',
          position: 'middle',
          duration: 1000
        })
        return
      }

      var options = {
        openid: JSON.parse(userInfo).openid,
        token: JSON.parse(userInfo).token
      }

      Indicator.open('加载中...')
      Tool.loadLocation(function(location, isSucced) {
        options.latitude = location.latitude
        options.longitude = location.longitude

        Fetch.loadCountyNearby(options).then(resp => {
          Indicator.close()
          if (resp.code === 0) {
            _this.$store.commit('updateCounties', resp.data.nearby)
          }
        }).catch(error => {
          Indicator.close()
          console.log(error)
        })
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// NICounty.vue?9bd72074